module.exports = __webpack_public_path__ + "media/img/naped-tyl-dark@3x-3e24ef64.svg";